/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import { HealthFragmentDoc } from "../../../shared/api/health/fragments.generated"
import * as Types from "../../../shared/types/__generated__/graphql"
import {
  ProjectChildrenFragmentDoc,
  ProjectFragmentDoc,
  ProjectSpecialPriceGroupsFragmentDoc,
  UserPermissionFragmentDoc
} from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProjectQueryVariables = Exact<{
  id: string
}>

export type ProjectQuery = {
  __typename: "Query"
  project?: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
  } | null
}

export type ProjectChildrenQueryVariables = Exact<{
  id: string
}>

export type ProjectChildrenQuery = {
  __typename: "Query"
  project?: {
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
    children?: Array<
      | {
          __typename: "Floor"
          id: string
          label?: string | null
          position: number
          createdAt: string
          updatedAt: string
          remark?: string | null
          hasClarificationRequest?: boolean | null
          children?: Array<{
            __typename: "Room"
            id: string
            label?: string | null
            number: string
            area?: number | null
            volume?: number | null
            utilization?: string | null
            height?: number | null
            personsNumber?: number | null
            airVolumePerArea?: number | null
            airVolumePerPerson?: number | null
            remark?: string | null
            sup?: number | null
            oda?: number | null
            eta?: number | null
            eha?: number | null
            tra?: number | null
            rca?: number | null
            ida?: number | null
            sec?: number | null
            soundPressureLevel?: number | null
            position: number
            createdAt: string
            updatedAt: string
            hasClarificationRequest?: boolean | null
            children?: Array<{
              __typename: "ProductPosition"
              id: string
              label?: string | null
              variantKey: string
              configurationKey?: string | null
              remark?: string | null
              quantity: number
              position: number
              displayPosition?: string | null
              isAlternative?: boolean | null
              price?: number | null
              priceGroup?: string | null
              hasClarificationRequest?: boolean | null
              references?: Array<{
                __typename: "ProductPositionInstallationReference"
                id: string
                title?: string | null
                permalink: string
                position: number
              }> | null
              addons?: Array<{
                __typename: "ProductPositionAddon"
                id: string
                variantKey: string
                parentProductType: string
              }> | null
              dimensioning?: {
                __typename: "ExternalDimensioningResult"
                transactionId: string
                environmentalVars?: Array<any> | null
                variantKeyData?: any
                dllVersion?: string | null
                language?: string | null
                technicalData?: Array<
                  | {
                      __typename: "ExternalDimensioningTechnicalDataDllVersion"
                      dllVersion: string
                    }
                  | {
                      __typename: "ExternalDimensioningTechnicalDataTable"
                      header?: Array<string> | null
                      content?: any
                      summary?: string | null
                      type?: string | null
                    }
                > | null
                technicalInput?: Array<{
                  __typename: "ExternalDimensioningTechnicalInput"
                  name: string
                  label?: string | null
                  unit?: string | null
                  value?: any
                  userSelected: boolean
                }> | null
                supplementaryText?: Array<{
                  __typename: "ExternalDimensioningSupplementaryText"
                  text: string
                }> | null
                transferData?: {
                  __typename: "ExternalDimensioningTransferData"
                  origin?: string | null
                } | null
              } | null
            }> | null
          }> | null
        }
      | {
          __typename: "ProductPosition"
          id: string
          label?: string | null
          variantKey: string
          configurationKey?: string | null
          remark?: string | null
          quantity: number
          position: number
          displayPosition?: string | null
          isAlternative?: boolean | null
          price?: number | null
          priceGroup?: string | null
          hasClarificationRequest?: boolean | null
          references?: Array<{
            __typename: "ProductPositionInstallationReference"
            id: string
            title?: string | null
            permalink: string
            position: number
          }> | null
          addons?: Array<{
            __typename: "ProductPositionAddon"
            id: string
            variantKey: string
            parentProductType: string
          }> | null
          dimensioning?: {
            __typename: "ExternalDimensioningResult"
            transactionId: string
            environmentalVars?: Array<any> | null
            variantKeyData?: any
            dllVersion?: string | null
            language?: string | null
            technicalData?: Array<
              | {
                  __typename: "ExternalDimensioningTechnicalDataDllVersion"
                  dllVersion: string
                }
              | {
                  __typename: "ExternalDimensioningTechnicalDataTable"
                  header?: Array<string> | null
                  content?: any
                  summary?: string | null
                  type?: string | null
                }
            > | null
            technicalInput?: Array<{
              __typename: "ExternalDimensioningTechnicalInput"
              name: string
              label?: string | null
              unit?: string | null
              value?: any
              userSelected: boolean
            }> | null
            supplementaryText?: Array<{
              __typename: "ExternalDimensioningSupplementaryText"
              text: string
            }> | null
            transferData?: {
              __typename: "ExternalDimensioningTransferData"
              origin?: string | null
            } | null
          } | null
        }
      | {
          __typename: "Room"
          id: string
          label?: string | null
          number: string
          area?: number | null
          volume?: number | null
          utilization?: string | null
          height?: number | null
          personsNumber?: number | null
          airVolumePerArea?: number | null
          airVolumePerPerson?: number | null
          remark?: string | null
          sup?: number | null
          oda?: number | null
          eta?: number | null
          eha?: number | null
          tra?: number | null
          rca?: number | null
          ida?: number | null
          sec?: number | null
          soundPressureLevel?: number | null
          position: number
          createdAt: string
          updatedAt: string
          hasClarificationRequest?: boolean | null
          children?: Array<{
            __typename: "ProductPosition"
            id: string
            label?: string | null
            variantKey: string
            configurationKey?: string | null
            remark?: string | null
            quantity: number
            position: number
            displayPosition?: string | null
            isAlternative?: boolean | null
            price?: number | null
            priceGroup?: string | null
            hasClarificationRequest?: boolean | null
            references?: Array<{
              __typename: "ProductPositionInstallationReference"
              id: string
              title?: string | null
              permalink: string
              position: number
            }> | null
            addons?: Array<{
              __typename: "ProductPositionAddon"
              id: string
              variantKey: string
              parentProductType: string
            }> | null
            dimensioning?: {
              __typename: "ExternalDimensioningResult"
              transactionId: string
              environmentalVars?: Array<any> | null
              variantKeyData?: any
              dllVersion?: string | null
              language?: string | null
              technicalData?: Array<
                | {
                    __typename: "ExternalDimensioningTechnicalDataDllVersion"
                    dllVersion: string
                  }
                | {
                    __typename: "ExternalDimensioningTechnicalDataTable"
                    header?: Array<string> | null
                    content?: any
                    summary?: string | null
                    type?: string | null
                  }
              > | null
              technicalInput?: Array<{
                __typename: "ExternalDimensioningTechnicalInput"
                name: string
                label?: string | null
                unit?: string | null
                value?: any
                userSelected: boolean
              }> | null
              supplementaryText?: Array<{
                __typename: "ExternalDimensioningSupplementaryText"
                text: string
              }> | null
              transferData?: {
                __typename: "ExternalDimensioningTransferData"
                origin?: string | null
              } | null
            } | null
          }> | null
        }
    > | null
    specialPriceGroups?: Array<{
      __typename: "SpecialPriceGroup"
      id: string
      name: string
      parentPriceGroup?: string | null
      productType: string
    }> | null
  } | null
}

export type ProjectsQueryVariables = Exact<{ [key: string]: never }>

export type ProjectsQuery = {
  __typename: "Query"
  projects?: Array<{
    __typename: "Project"
    id: string
    title: string
    description?: string | null
    position: number
    priceList?: string | null
    inflationSurcharge?: number | null
    createdAt: string
    updatedAt: string
    lastChanged?: string | null
    hasClarificationRequest?: boolean | null
    ui?: { __typename: "ProjectUI"; color?: string | null } | null
    lastChangedBy?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
    team?: { __typename: "ProjectTeamID"; id: string } | null
  }> | null
}

export type ProjectsHealthQueryVariables = Exact<{ [key: string]: never }>

export type ProjectsHealthQuery = {
  __typename: "Query"
  projectsHealth?: { __typename: "Health"; isAvailable: boolean } | null
}

export type AllProjectPermissionsQueryVariables = Exact<{
  [key: string]: never
}>

export type AllProjectPermissionsQuery = {
  __typename: "Query"
  allProjectPermissions?: Array<{
    __typename: "UserPermission"
    id: string
    resourceType: string
    resourceId: string
    role: string
    permissions?: {
      __typename: "ProjectPermissions"
      view_project: boolean
      edit_project: boolean
      edit_position_price: boolean
      edit_position_price_group: boolean
      create_special_price_group: boolean
      delete_project: boolean
      invite_members: boolean
    } | null
  }> | null
}

export type ProjectPermissionsQueryVariables = Exact<{
  projectID: string
}>

export type ProjectPermissionsQuery = {
  __typename: "Query"
  projectPermissions: {
    __typename: "UserPermission"
    id: string
    resourceType: string
    resourceId: string
    role: string
    permissions?: {
      __typename: "ProjectPermissions"
      view_project: boolean
      edit_project: boolean
      edit_position_price: boolean
      edit_position_price_group: boolean
      create_special_price_group: boolean
      delete_project: boolean
      invite_members: boolean
    } | null
  }
}

export const ProjectDocument = gql`
  query Project($id: ID!) {
    project(id: $id)
      @rest(
        type: "Project"
        endpoint: "project"
        path: "/project-list/projects/{args.id}"
      ) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectQuery(
  baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables> &
    ({ variables: ProjectQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options
  )
}
export function useProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options
  )
}
// @ts-ignore
export function useProjectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectQuery,
    ProjectQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ProjectQuery, ProjectQueryVariables>
export function useProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ProjectQuery | undefined,
  ProjectQueryVariables
>
export function useProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options
  )
}
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>
export type ProjectSuspenseQueryHookResult = ReturnType<
  typeof useProjectSuspenseQuery
>
export type ProjectQueryResult = Apollo.QueryResult<
  ProjectQuery,
  ProjectQueryVariables
>
export const ProjectChildrenDocument = gql`
  query ProjectChildren($id: ID!) {
    project(id: $id)
      @rest(
        type: "Project"
        endpoint: "project"
        path: "/project-list/projects/{args.id}?include=subtree"
      ) {
      ...Project
      ...ProjectChildren
      ...ProjectSpecialPriceGroups
    }
  }
  ${ProjectFragmentDoc}
  ${ProjectChildrenFragmentDoc}
  ${ProjectSpecialPriceGroupsFragmentDoc}
`

/**
 * __useProjectChildrenQuery__
 *
 * To run a query within a React component, call `useProjectChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChildrenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectChildrenQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectChildrenQuery,
    ProjectChildrenQueryVariables
  > &
    (
      | { variables: ProjectChildrenQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectChildrenQuery, ProjectChildrenQueryVariables>(
    ProjectChildrenDocument,
    options
  )
}
export function useProjectChildrenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectChildrenQuery,
    ProjectChildrenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProjectChildrenQuery,
    ProjectChildrenQueryVariables
  >(ProjectChildrenDocument, options)
}
// @ts-ignore
export function useProjectChildrenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectChildrenQuery,
    ProjectChildrenQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectChildrenQuery,
  ProjectChildrenQueryVariables
>
export function useProjectChildrenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectChildrenQuery,
        ProjectChildrenQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectChildrenQuery | undefined,
  ProjectChildrenQueryVariables
>
export function useProjectChildrenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectChildrenQuery,
        ProjectChildrenQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectChildrenQuery,
    ProjectChildrenQueryVariables
  >(ProjectChildrenDocument, options)
}
export type ProjectChildrenQueryHookResult = ReturnType<
  typeof useProjectChildrenQuery
>
export type ProjectChildrenLazyQueryHookResult = ReturnType<
  typeof useProjectChildrenLazyQuery
>
export type ProjectChildrenSuspenseQueryHookResult = ReturnType<
  typeof useProjectChildrenSuspenseQuery
>
export type ProjectChildrenQueryResult = Apollo.QueryResult<
  ProjectChildrenQuery,
  ProjectChildrenQueryVariables
>
export const ProjectsDocument = gql`
  query Projects {
    projects
      @rest(
        type: "Project"
        endpoint: "project"
        path: "/project-list/projects"
      ) {
      ...Project
    }
  }
  ${ProjectFragmentDoc}
`

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options
  )
}
export function useProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectsQuery,
    ProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options
  )
}
// @ts-ignore
export function useProjectsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectsQuery,
    ProjectsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ProjectsQuery, ProjectsQueryVariables>
export function useProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ProjectsQuery | undefined,
  ProjectsQueryVariables
>
export function useProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options
  )
}
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>
export type ProjectsLazyQueryHookResult = ReturnType<
  typeof useProjectsLazyQuery
>
export type ProjectsSuspenseQueryHookResult = ReturnType<
  typeof useProjectsSuspenseQuery
>
export type ProjectsQueryResult = Apollo.QueryResult<
  ProjectsQuery,
  ProjectsQueryVariables
>
export const ProjectsHealthDocument = gql`
  query ProjectsHealth {
    projectsHealth
      @rest(type: "Health", endpoint: "health", path: "/project-list/health") {
      ...Health
    }
  }
  ${HealthFragmentDoc}
`

/**
 * __useProjectsHealthQuery__
 *
 * To run a query within a React component, call `useProjectsHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectsHealthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProjectsHealthQuery,
    ProjectsHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectsHealthQuery, ProjectsHealthQueryVariables>(
    ProjectsHealthDocument,
    options
  )
}
export function useProjectsHealthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectsHealthQuery,
    ProjectsHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectsHealthQuery, ProjectsHealthQueryVariables>(
    ProjectsHealthDocument,
    options
  )
}
// @ts-ignore
export function useProjectsHealthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectsHealthQuery,
    ProjectsHealthQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectsHealthQuery,
  ProjectsHealthQueryVariables
>
export function useProjectsHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectsHealthQuery,
        ProjectsHealthQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectsHealthQuery | undefined,
  ProjectsHealthQueryVariables
>
export function useProjectsHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectsHealthQuery,
        ProjectsHealthQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectsHealthQuery,
    ProjectsHealthQueryVariables
  >(ProjectsHealthDocument, options)
}
export type ProjectsHealthQueryHookResult = ReturnType<
  typeof useProjectsHealthQuery
>
export type ProjectsHealthLazyQueryHookResult = ReturnType<
  typeof useProjectsHealthLazyQuery
>
export type ProjectsHealthSuspenseQueryHookResult = ReturnType<
  typeof useProjectsHealthSuspenseQuery
>
export type ProjectsHealthQueryResult = Apollo.QueryResult<
  ProjectsHealthQuery,
  ProjectsHealthQueryVariables
>
export const AllProjectPermissionsDocument = gql`
  query AllProjectPermissions {
    allProjectPermissions
      @rest(
        type: "UserPermission"
        endpoint: "allUserPermissions"
        path: "/project-list/user-permissions?resourceType=projects"
      ) {
      ...UserPermission
    }
  }
  ${UserPermissionFragmentDoc}
`

/**
 * __useAllProjectPermissionsQuery__
 *
 * To run a query within a React component, call `useAllProjectPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProjectPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProjectPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllProjectPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllProjectPermissionsQuery,
    AllProjectPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AllProjectPermissionsQuery,
    AllProjectPermissionsQueryVariables
  >(AllProjectPermissionsDocument, options)
}
export function useAllProjectPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllProjectPermissionsQuery,
    AllProjectPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AllProjectPermissionsQuery,
    AllProjectPermissionsQueryVariables
  >(AllProjectPermissionsDocument, options)
}
// @ts-ignore
export function useAllProjectPermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AllProjectPermissionsQuery,
    AllProjectPermissionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  AllProjectPermissionsQuery,
  AllProjectPermissionsQueryVariables
>
export function useAllProjectPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllProjectPermissionsQuery,
        AllProjectPermissionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  AllProjectPermissionsQuery | undefined,
  AllProjectPermissionsQueryVariables
>
export function useAllProjectPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllProjectPermissionsQuery,
        AllProjectPermissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AllProjectPermissionsQuery,
    AllProjectPermissionsQueryVariables
  >(AllProjectPermissionsDocument, options)
}
export type AllProjectPermissionsQueryHookResult = ReturnType<
  typeof useAllProjectPermissionsQuery
>
export type AllProjectPermissionsLazyQueryHookResult = ReturnType<
  typeof useAllProjectPermissionsLazyQuery
>
export type AllProjectPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useAllProjectPermissionsSuspenseQuery
>
export type AllProjectPermissionsQueryResult = Apollo.QueryResult<
  AllProjectPermissionsQuery,
  AllProjectPermissionsQueryVariables
>
export const ProjectPermissionsDocument = gql`
  query ProjectPermissions($projectID: ID!) {
    projectPermissions(projectID: $projectID)
      @rest(
        type: "UserPermission"
        endpoint: "userPermissions"
        path: "/project-list/user-permissions?resourceType=projects&resourceId={args.projectID}"
      ) {
      ...UserPermission
    }
  }
  ${UserPermissionFragmentDoc}
`

/**
 * __useProjectPermissionsQuery__
 *
 * To run a query within a React component, call `useProjectPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPermissionsQuery({
 *   variables: {
 *      projectID: // value for 'projectID'
 *   },
 * });
 */
export function useProjectPermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectPermissionsQuery,
    ProjectPermissionsQueryVariables
  > &
    (
      | { variables: ProjectPermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProjectPermissionsQuery,
    ProjectPermissionsQueryVariables
  >(ProjectPermissionsDocument, options)
}
export function useProjectPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectPermissionsQuery,
    ProjectPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProjectPermissionsQuery,
    ProjectPermissionsQueryVariables
  >(ProjectPermissionsDocument, options)
}
// @ts-ignore
export function useProjectPermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectPermissionsQuery,
    ProjectPermissionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProjectPermissionsQuery,
  ProjectPermissionsQueryVariables
>
export function useProjectPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectPermissionsQuery,
        ProjectPermissionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectPermissionsQuery | undefined,
  ProjectPermissionsQueryVariables
>
export function useProjectPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectPermissionsQuery,
        ProjectPermissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProjectPermissionsQuery,
    ProjectPermissionsQueryVariables
  >(ProjectPermissionsDocument, options)
}
export type ProjectPermissionsQueryHookResult = ReturnType<
  typeof useProjectPermissionsQuery
>
export type ProjectPermissionsLazyQueryHookResult = ReturnType<
  typeof useProjectPermissionsLazyQuery
>
export type ProjectPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useProjectPermissionsSuspenseQuery
>
export type ProjectPermissionsQueryResult = Apollo.QueryResult<
  ProjectPermissionsQuery,
  ProjectPermissionsQueryVariables
>
